
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policies/sales-tax",
      function () {
        return require("private-next-pages/policies/sales-tax.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policies/sales-tax"])
      });
    }
  